export default "/fonts/vendor/@fontsource/fraunces/files/fraunces-latin-300-normal.woff2?16460d0468f6e96ec6a4ec3dc6e43c37";